import React, { useEffect, useState, useContext } from 'react';
import { LanguageContext } from 'contexts/LanguageContext';
import { Skeleton, Modal, Card, Row, Col, Alert } from 'antd';
import message from '../../utils/messageWithScroll';
import { EditFilled, DeleteFilled } from '@ant-design/icons';
import '../../styles/permissions.css';
import { api } from 'services/api';
import CreateGroupIndex from './CreateGroupIndex';
import EditGroupIndex from './EditGroupIndex';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { FormattedMessage } from 'react-intl';
import NotifiableUsers from './NotifiableUsers';
import CrossSellPermissions from 'components/CrossSellBanners/CrossSellPermissions';
const { confirm } = Modal;

function PermissionIndex({ number, setActiveTabKey, setActiveTabTutorialKey }) {
	const { dictionary } = useContext(LanguageContext);
	const [domain, setDomain] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [editingGroup, setEditingGroup] = useState([]);
	const [data, setData] = useState([]);
	const [isCreateGroupIndex, setIsCreateGroupIndex] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		window.BX24.init(async () => {
			const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };
			const domain = auth.domain;
			setDomain(domain);

			await getClientGroups(domain);
		});
	}, [number.numbers.actives, number.numbers.inactives]);

	const getClientGroups = async (domain) => {
		const request = {
			domain,
		};

		const groups = await api.post('getAllPermissionGroups', request);

		setData(groups.data);
		setIsLoading(false);
	};

	const handleDelete = async (record) => {
		confirm({
			title: dictionary.permission_deleted_notification,
			okText: dictionary.btn_delete_ok,
			okType: 'danger',
			onOk: async () => {
				setData((prevState) => {
					return prevState.filter((group) => group.key !== record.key);
				});
				await api
					.post('deletePermissionGroup', {
						record,
					})
					.then(() => {
						message.success(dictionary.delete_group_success);
						getClientGroups(domain);
					})
					.catch((err) => {
						if (err.message) {
							message.error(err.message);
						} else {
							message.error(dictionary.delete_group_error);
						}
					});
			},
			cancelText: dictionary.btn_delete_cancel,
		});
	};

	const handleClick = () => {
		setActiveTabKey('6');
		setActiveTabTutorialKey('7');
	};

	const goToCreateGroupIndex = () => {
		setIsCreateGroupIndex(true);
	};

	if (isLoading) {
		return <Skeleton />;
	}

	if (isCreateGroupIndex) {
		return <CreateGroupIndex setData={setData} />;
	}

	if (isEditing) {
		return (
			<EditGroupIndex
				editingGroup={editingGroup}
				setEditingGroup={setEditingGroup}
				setData={setData}
			/>
		);
	}

	return (
		<>
			<Card title={<FormattedMessage id="permission_title" />} style={{ width: 'auto', margin: 5 }}>
				<Row>
					<div style={{ padding: 12 }}>
						<button
							className="btn-permission float-right"
							onClick={() => goToCreateGroupIndex()}
							style={{ cursor: 'pointer' }}
						>
							<FormattedMessage id="new_group" />
						</button>
					</div>
				</Row>
				<div
					style={{
						backgroundColor: '#e8f9fe',
						padding: 12,
						borderBottom: '1px solid #fff',
					}}
				>
					<Row>
						<Col
							span={6}
							style={{
								lineHeight: '25px',
								fontWeight: 'bold',
							}}
						>
							<FormattedMessage id="group_name" />
						</Col>
						<Col
							span={6}
							style={{
								lineHeight: '25px',
								fontWeight: 'bold',
							}}
						>
							<FormattedMessage id="numbers" />
						</Col>
						<Col
							span={6}
							style={{
								lineHeight: '25px',
								fontWeight: 'bold',
							}}
						>
							<FormattedMessage id="users" />
						</Col>

						<Col
							span={3}
							style={{
								lineHeight: '25px',
								fontWeight: 'bold',
							}}
						>
							<FormattedMessage id="group_actions" />
						</Col>
					</Row>
				</div>
				{data.map((group, index) => (
					<div key={group.groupId} style={{ backgroundColor: '#e8f9fe', padding: 12 }}>
						<Row>
							<Col
								span={6}
								style={{
									lineHeight: '32px',
								}}
							>
								{group.groupName ? group.groupName : '-'}
							</Col>
							<Col span={6} style={{ lineHeight: '32px' }}>
								{group.numbers.map((number, index) => {
									if (index === group.numbers.length - 1) {
										return number?.name ? `${number?.name}` : number?.number;
									} else {
										return number?.name ? `${number?.name}, ` : number?.number + ', ';
									}
								})}
							</Col>
							<Col span={6} style={{ lineHeight: '32px' }}>
								{group.users.slice(0, 2).map((user, index) => {
									if (index === group.users.length - 1) {
										return user?.name ? `${user?.name}` : '-';
									} else {
										return user?.name ? `${user?.name}, ` : '-';
									}
								})}
								{group.users.length > 2 ? `+ ${group.users.length - 2}` : null}
							</Col>
							<Col span={6} style={{ lineHeight: '32px' }} id="actions-col">
								<button
									className="btn-action btn-edit"
									onClick={() => {
										setEditingGroup(data[index]);

										setIsEditing(true);
									}}
								>
									<EditFilled />
									<p className="btn-text">{dictionary.edit}</p>
								</button>
								<button
									className="btn-action btn-delete"
									onClick={() => {
										handleDelete(data[index]);
									}}
								>
									<DeleteFilled />
									<p className="btn-text">{dictionary.delete}</p>
								</button>
							</Col>
						</Row>
					</div>
				))}
			</Card>
			<Card title={<FormattedMessage id="notifications" />} style={{ width: 'auto', margin: 5 }}>
				<Row>
					<NotifiableUsers />
				</Row>
				<Row>
					<CrossSellPermissions />
				</Row>
			</Card>
		</>
	);
}

export default NumberConsumer(PermissionIndex);
